import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.less'
})
export class EmptyStateComponent {

  @Input() iconName: string = 'heart';
  @Input() title: string = 'No tienes reportes favoritos'
  @Input() description: string = 'Agrega reportes a favoritos para acceder rápidamente desde aquí.'

}
